export default "__VITE_ASSET__C0yX2TIY__"